import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "flex mr-3 pt-2" }
const _hoisted_3 = { class: "flex" }

import { ref, toRefs } from 'vue';
import Calendar from 'primevue/calendar';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import { useUtilizationStore } from '@/store';
import { useDateTime, usePersonTypes } from '@/composables';
import { TimeRatioReportingSPTableInterface } from '@/types';

interface TimeUsageModalPropsInterface {
  timeRatioData: TimeRatioReportingSPTableInterface[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeRatioReportingServiceProvider',
  props: {
    timeRatioData: {}
  },
  setup(__props: any) {

const props = __props;
const { timeRatioData } = toRefs(props);

const utilizationStore = useUtilizationStore();
const maxDate = ref<Date>(useDateTime().getMostRecentSunday());
const minDate = ref<Date>(new Date('2024-01-02'));
const dateSelect = ref<Date>(new Date(utilizationStore.serviceProviderTimeRatioFilterDate));

const onDateSelect = async (value: Date) => {
  dateSelect.value = value;
  await utilizationStore.updateServiceProviderTimeRatioFilterDate(dateSelect.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, { class: "flex-none flex flex-column" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            name: "pie_chart",
            class: "material-icons text-color-blue mr-2"
          }),
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Time Ratio Reporting up to:", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Calendar), {
            modelValue: dateSelect.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateSelect).value = $event)),
            "show-icon": "",
            "disabled-days": [1, 2, 3, 4, 5, 6],
            "icon-display": "input",
            class: "text-sm",
            "date-format": "MM dd, yy",
            "max-date": maxDate.value,
            "min-date": minDate.value,
            onDateSelect: onDateSelect
          }, null, 8, ["modelValue", "max-date", "min-date"])
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _unref(timeRatioData),
        "data-id": "contract_id",
        "show-gridlines": "",
        "responsive-layout": "scroll",
        "sort-field": "indirect_percent",
        "sort-order": -1
      }, {
        empty: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createElementVNode("span", { textContent: 'No data to display' }, null, -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_unref(ColumnGroup), { type: "header" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Row), null, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Organization",
                    field: "organization",
                    sortable: "",
                    rowspan: 2
                  }),
                  _createVNode(_component_Column, {
                    header: "Contract",
                    field: "contract_quote_number",
                    sortable: "",
                    rowspan: 2
                  }),
                  (!_unref(usePersonTypes).isClinician())
                    ? (_openBlock(), _createBlock(_component_Column, {
                        key: 0,
                        header: "Type",
                        field: "contract_type",
                        sortable: "",
                        rowspan: 2
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Column, {
                    header: "Weeks",
                    field: "weeks",
                    sortable: "",
                    rowspan: 2
                  }),
                  _createVNode(_component_Column, {
                    colspan: 2,
                    "header-class": "relative justify-content-center flex-none"
                  }, {
                    header: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("span", null, "Billed Direct Time", -1)),
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "info",
                        class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
                      }, null, 512), [
                        [
                          _directive_tooltip,
                          'Time billed for Session, Consultation, Response to Intervention events',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    colspan: 2,
                    "header-class": "relative justify-content-center flex-none"
                  }, {
                    header: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "Billed Indirect Time", -1)),
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "info",
                        class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
                      }, null, 512), [
                        [
                          _directive_tooltip,
                          'Time billed for Caseload Management, Record Review, IEP Meeting events',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    colspan: 2,
                    "header-class": "relative justify-content-center flex-none"
                  }, {
                    header: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "Billed Evaluation Time", -1)),
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "info",
                        class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
                      }, null, 512), [
                        [
                          _directive_tooltip,
                          'Time billed for Evaluation events',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Row), null, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Hrs",
                    field: "direct_hours",
                    sortable: "",
                    "header-class": "justify-content-center flex-none"
                  }),
                  _createVNode(_component_Column, {
                    header: "%",
                    field: "direct_percent",
                    sortable: "",
                    "header-class": "justify-content-center flex-none"
                  }),
                  _createVNode(_component_Column, {
                    header: "Hrs",
                    field: "indirect_hours",
                    sortable: "",
                    "header-class": "justify-content-center flex-none"
                  }),
                  _createVNode(_component_Column, {
                    header: "%",
                    field: "indirect_percent",
                    sortable: "",
                    "header-class": "justify-content-center flex-none"
                  }),
                  _createVNode(_component_Column, {
                    header: "Hrs",
                    field: "eval_hours",
                    sortable: "",
                    "header-class": "justify-content-center flex-none"
                  }),
                  _createVNode(_component_Column, {
                    header: "%",
                    field: "eval_percent",
                    sortable: "",
                    "header-class": "justify-content-center flex-none"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { field: "organization" }),
          _createVNode(_component_Column, { field: "contract_quote_number" }),
          (!_unref(usePersonTypes).isClinician())
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "contract_type"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, { field: "weeks" }),
          _createVNode(_component_Column, {
            field: "direct_hours",
            "body-class": "justify-content-center flex-none"
          }),
          _createVNode(_component_Column, {
            field: "direct_percent",
            "body-class": "percentage justify-content-center flex-none"
          }),
          _createVNode(_component_Column, {
            field: "indirect_hours",
            "body-class": "justify-content-center flex-none"
          }),
          _createVNode(_component_Column, {
            field: "indirect_percent",
            "body-class": "percentage justify-content-center flex-none"
          }),
          _createVNode(_component_Column, {
            field: "eval_hours",
            "body-class": "justify-content-center flex-none"
          }),
          _createVNode(_component_Column, {
            field: "eval_percent",
            "body-class": "percentage justify-content-center flex-none"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})